import React, {Component} from 'react';
import {connect} from 'react-redux';
import {storeNonEngineer} from '../../../actions';
import NewNonEngineer from '../../shared/NewNonEngineer';


class NewNonEngineerContainer extends Component {
    render() {
        return <NewNonEngineer {...this.props}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        belongsTo: state.me.application.id,
        branches: state.landlord.branches
    }
};
export default connect(mapStateToProps, {storeNonEngineer})(NewNonEngineerContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/DLO/NewNonEngineerContainer.js